export { default } from './ScoredCardNotFound'
